import { StandardEvents } from '@shopify/events';

/**
 * Swaps a variant metafield's text when the customer changes options,
 * following the same pattern as Horizon's product-price component: the
 * variant picker fetches the section for the new variant and each block
 * pulls its own updated markup out of that HTML.
 */
class SarajVariantText extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {Event & { promise?: Promise<any> }} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;

        const updated = detail.html.querySelector(`saraj-variant-text[data-block-id="${this.dataset.blockId}"]`);
        if (!updated) return;

        this.innerHTML = updated.innerHTML;
        this.hidden = updated.hasAttribute('hidden');
      })
      .catch(() => {});
  };
}

if (!customElements.get('saraj-variant-text')) {
  customElements.define('saraj-variant-text', SarajVariantText);
}
